<template>
  <input
      class="Nomerpick__inp"

      :class="{invalid:!isValid}"
      :value="localValue"
      @input="onInput"

      type="text"
      inputmode="numeric"
      autocomplete="off"
      :placeholder="props.placeholder"
      maxlength="8"
      v-bind="$attrs"
  >
</template>

<script setup>
import {
  ref,
  computed,
  watch,
  onBeforeUnmount,
} from 'vue'

const props = defineProps({
  value: {
    type: String,
    default: '',
  },

  placeholder: {
    type: String,
    default: '',
  },
})

const emit = defineEmits(['input'])

const localValue = ref(props.value)

let debounceTimer = null

const validate = value =>
  '' === value || /^[0-9]{6,8}$/.test(value)

const isValid = computed(() => {
  let ret = validate(localValue.value)
  return ret
})

const emitValue = () => {
  const value = localValue.value

  if (validate(value)) {
    emit('input', value)
  }
}

const emitValueDebounced = () => {
  clearTimeout(debounceTimer)

  debounceTimer = setTimeout(emitValue, 300)
}

const onInput = event => {
  const input = event.target

  const value = input.value
    .replace(/\D/g, '')
    .slice(0, 8)

  localValue.value = value

  if (input.value !== value) {
    input.value = value
  }

  emitValueDebounced()
}

watch(
  () => props.value,
  value => {
    localValue.value = value
  },
)

onBeforeUnmount(() => {
  clearTimeout(debounceTimer)
})
</script>

<style lang="scss">
.Nomerpick  {
  &__inp {
    border: 1px solid #e0e0e0;
    font-family: 'Bliss';
    font-size: 1rem;
    line-height: 1.62;
    padding: 6px 12px;
    box-shadow: none;
    border-radius: 5px;
    color: #555;
    transition: border-color 0.15s ease-in-out 0s, box-shadow 0.15s ease-in-out 0s;
    width: 100px;

    &:focus,
    &:hover {
      outline: none;
      box-shadow: 0 0px 0px 2px #565656 inset;
    }
    &.invalid,&.invalid:focus {box-shadow: 0 0px 0px 2px #ff5656;}

  }
}    
  
</style>
